import shortcodes_controller from '../shortcodes/shortcodes_controller'

const policy = () => layData.navigation_policy || {}

export function requiresFullPageLoad(page, href) {
	if (!policy().enabled) return false
	if (!page || !page.id || !page.type || page.type === 'custom') return true
	if ((policy().allowedTypes || []).indexOf(page.type) === -1) return true
	if ((page.type === 'category' || page.type === 'archive') && (policy().blockedArchiveIds || []).indexOf(Number(page.id)) !== -1) return true
	if (page.type === 'product' || page.type === 'product_variation' || page.type.indexOf('product_') === 0) return true
	if (page.type !== 'category' && page.type !== 'archive' && (policy().blockedPageIds || []).indexOf(Number(page.id)) !== -1) return true
	if (shortcodes_controller.pageContainsShortcode(page)) return true
	if (href) {
		let url
		try { url = new URL(href, window.location.href) } catch (error) { return true }
		if (url.origin !== window.location.origin) return true
		// Preserve Woo actions, searches, filters, plain permalinks and plugin endpoints.
		if (url.search) return true
		if ((policy().blockedUrls || []).some(value => {
			const blocked = new URL(value, window.location.href)
			const path = blocked.pathname.replace(/\/$/, '')
			return path !== '' && (url.pathname.replace(/\/$/, '') === path || url.pathname.indexOf(path + '/') === 0)
		})) return true
	}
	return false
}

export function getFullPageLoadContext(page, href) {
	return {
		fromBlocked: !!policy().currentBlocked,
		toBlocked: requiresFullPageLoad(page, href),
	}
}

export function canUseAjaxNavigation(page, href) {
	return layData.misc_options_disable_ajax !== 'on' && !policy().currentBlocked && !requiresFullPageLoad(page, href)
}

export function canCachePage(page, href) {
	return !requiresFullPageLoad(page, href)
}
